import { Link } from "react-router-dom";
import { seoArticles } from "@/mocks/homeData";

export default function ArticleCards() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs uppercase tracking-widest text-secondary-500 font-label">/ SEO Resources</span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-950 mt-3 mb-4">
            <strong>Mulebuy Spreadsheet</strong> Guides & Articles
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            In-depth articles covering everything from safety and verification to advanced sourcing strategies — all optimized for your product research journey.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-4 text-accent-600 text-sm font-medium">
                  Read Article
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}